import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import axios from "axios";
axios.defaults.validateStatus = null;
const rootElement = document.getElementById("root");

ReactDOM.render(<App />, rootElement);
